<div class="wrap">
    <ng-container *ngFor="let n of nav">
        <div class="card" *ngIf="n.title !== 'Accueil'" (click)="goRedirection(n.title , n.route)">
           <div class="img">
               <fa-icon [icon]="n.icon"></fa-icon>
               <img class="img_bg_ramdam" src="assets/img/bg_btn_ramdam_remove_bg.png" alt="">
           </div>
           <div class="description">
               <h3>{{n.title}}</h3>
               <p>{{n.description}}</p>
           </div>
        </div>
    </ng-container>
  
</div>